// GetStudentNotes.js

import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Input,
  Button,
  Spin,
  Empty,
  Skeleton,
} from "antd";

import {
  SearchOutlined,
  DownloadOutlined,
  BookOutlined,
} from "@ant-design/icons";

import { toast } from "react-toastify";
import api from "../../api/api";

import "./GetStudentNotes.css";


const { Title, Text } = Typography;


const bookColors = [
  "#8B0000",
  "#1B4D3E",
  "#1E3A8A",
  "#7C2D12",
  "#4C1D95",
  "#065F46",
];


const GetStudentNotes = () => {

  const [notes,setNotes] = useState([]);
  const [search,setSearch] = useState("");
  const [loading,setLoading] = useState(true);
  const [searchLoading,setSearchLoading] = useState(false);


  const fetchNotes = async(query="")=>{

    try{

      const res = await api.get(`/notes/?search=${query}`);

      setNotes(res.data);

    }catch(error){

      console.log(error);
      toast.error("Failed to load notes");

    }

  };


  useEffect(()=>{

    const load = async()=>{

      setLoading(true);

      await fetchNotes();

      setLoading(false);

    };

    load();

  },[]);



  useEffect(()=>{

    const timer = setTimeout(async()=>{

      setSearchLoading(true);

      await fetchNotes(search);

      setSearchLoading(false);

    },400);


    return ()=>clearTimeout(timer);


  },[search]);





  if(loading){

    return (

      <div className="library-container">

        <Row gutter={[24,24]}>

          {[1,2,3,4].map(item=>(

            <Col xs={24} sm={12} md={8} key={item}>

              <Card>

                <Skeleton active/>

              </Card>

            </Col>

          ))}

        </Row>

      </div>

    );

  }




return (

<div className="library-container">


{/* HEADER */}

<div className="library-header">


<BookOutlined className="library-icon"/>


<div>

<Title level={2}>
Student Notes Library
</Title>

<Text>
Explore your digital bookshelf and download learning materials.
</Text>

</div>


</div>




{/* SEARCH */}

<div className="search-box">


<Input

size="large"

placeholder="Search books by title..."

prefix={<SearchOutlined/>}

value={search}

onChange={(e)=>setSearch(e.target.value)}

/>


</div>




{
searchLoading &&

<div className="loading">

<Spin/>

</div>

}




{/* BOOK SHELF */}


<div className="bookshelf">


<Row gutter={[28,28]}>


{

notes.length===0 ?

(

<Col span={24}>

<Empty description="No books found in library"/>

</Col>

)

:

notes.map((note,index)=>(


<Col

xs={24}

sm={12}

md={8}

lg={6}

key={note.id}

>



<div

className="book-wrapper"

>


<Card

bordered={false}

className="book-card"


style={{

background:

bookColors[index % bookColors.length]

}}

>



<div className="book-cover">


<div className="book-title">

{note.title}

</div>


<div className="book-author">

By {note.teacher?.username}

</div>


</div>



<div className="book-body">


<Text>

{note.description ||

"No description available"}

</Text>


<Button

type="primary"

block

icon={<DownloadOutlined/>}

href={note.file}

target="_blank"

rel="noopener noreferrer"

>

Open Book

</Button>



</div>



</Card>



</div>



</Col>


))

}



</Row>


</div>



</div>


);


};


export default GetStudentNotes;


// // GetStudentNotes.js
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   CardActions,
//   Typography,
//   Button,
//   CircularProgress,
//   TextField,
// } from "@mui/material";
// import { toast } from "react-toastify";
// import api from "../../api/api";

// const GetStudentNotes = () => {
//   const [notes, setNotes] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [searchLoading, setSearchLoading] = useState(false);

//   // Debounce timer
//   const [debounceTimer, setDebounceTimer] = useState(null);

//   const fetchNotes = async (query = "") => {
//     try {
//       const res = await api.get(`/notes/?search=${query}`);
//       setNotes(res.data);
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load notes");
//     }
//   };

//   // Load initial notes
//   useEffect(() => {
//     const loadData = async () => {
//       setLoading(true);
//       await fetchNotes();
//       setLoading(false);
//     };
//     loadData();
//   }, []);

//   // Debounced search
//   useEffect(() => {
//     if (debounceTimer) clearTimeout(debounceTimer);

//     const timer = setTimeout(async () => {
//       setSearchLoading(true);
//       await fetchNotes(search);
//       setSearchLoading(false);
//     }, 300); // Delay for performance

//     setDebounceTimer(timer);
//   }, [search]);

//   if (loading)
//     return (
//       <Box textAlign="center" mt={5}>
//         <CircularProgress />
//       </Box>
//     );

//   return (
//     <Box p={3}>
//       <Typography variant="h5" mb={3}>
//         Your Notes Library
//       </Typography>

//       {/* Search Input */}
//       <TextField
//         label="Search by title"
//         variant="outlined"
//         fullWidth
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         sx={{ mb: 3 }}
//       />

//       {searchLoading && (
//         <Box textAlign="center" mb={2}>
//           <CircularProgress size={28} />
//         </Box>
//       )}

//       <Grid container spacing={3}>
//         {notes.length === 0 && (
//           <Typography>No notes found.</Typography>
//         )}

//         {notes.map((note) => (
//           <Grid item xs={12} sm={6} md={4} key={note.id}>
//             <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   {note.title}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" gutterBottom>
//                   {note.description || "No description provided."}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Posted by: {note.teacher.username}
//                 </Typography>
//               </CardContent>

//               <CardActions sx={{ mt: "auto" }}>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   fullWidth
//                   href={note.file}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Download
//                 </Button>
//               </CardActions>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default GetStudentNotes;
